import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import React__default, { useState, useEffect } from 'react';
import { A as AppTextInput } from './index-c2a07f56.esm.js';
import { A as AppText, a as AppIcon } from './index-6b88191c.esm.js';
import { A as AppAssets } from './index-3256db5b.esm.js';
import { View } from 'react-native';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { A as AppInputLabel } from './index-5ae71f5a.esm.js';
import { A as AppTrackSlider } from './index-182c2016.esm.js';

const AppSecureTextInput = _ref => {
  var _currentTheme$theme;
  let {
    isEditable,
    inputType = "TEXT",
    showTextInputLabel,
    label,
    isMandatory,
    wrapperStyleSecureTextInput,
    textInputLabelStyleCore,
    coreViewStyle,
    labelStyle,
    actionsButtonsViewStyle,
    isEditEnabled = true,
    initialValue,
    onSubmitIconPress = v => {},
    onCancelIconPress = () => {},
    onEditIconPress = () => {},
    onSliderValueChange = v => {},
    children,
    unitLabel,
    actionsStyle,
    wrapperStyleNonEditable,
    showEditButtons = true,
    ...props
  } = _ref;
  const [inputValue, setInputValue] = useState(initialValue);
  useEffect(() => {
    setInputValue(initialValue);
  }, [initialValue]);
  useEffect(() => {
    if (inputType === "SLIDER") {
      onSliderValueChange(inputValue);
    }
  }, [inputValue]);
  const {
    currentTheme
  } = useTheme();
  const renderInput = () => {
    switch (inputType) {
      case "TEXT":
        return /*#__PURE__*/React__default.createElement(AppTextInput, _extends({
          onChangeText: v => {
            setInputValue(v);
          }
        }, props, {
          value: inputValue
        }));
      case "SLIDER":
        return /*#__PURE__*/React__default.createElement(AppTrackSlider, _extends({
          key: initialValue,
          unitLabel: unitLabel,
          value: inputValue || initialValue,
          onValueChange: v => setInputValue(v)
        }, props, {
          wrapperStyle: {
            marginRight: 10,
            flex: 1,
            flexDirection: "row",
            alignItems: "center"
          }
        }));
    }
  };
  return /*#__PURE__*/React__default.createElement(View, {
    style: [{
      flexDirection: "column"
    }, wrapperStyleSecureTextInput]
  }, showTextInputLabel ? /*#__PURE__*/React__default.createElement(AppInputLabel, {
    style: textInputLabelStyleCore,
    isMandatory: isMandatory,
    label: label
  }) : null, /*#__PURE__*/React__default.createElement(View, {
    style: [{
      flex: 1,
      justifyContent: "space-between",
      flexDirection: "row"
    }, coreViewStyle]
  }, isEditable ? renderInput() : /*#__PURE__*/React__default.createElement(AppText, {
    wrapperStyle: wrapperStyleNonEditable,
    style: [{
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.small_font_size
    }, labelStyle]
  }, initialValue), showEditButtons && /*#__PURE__*/React__default.createElement(View, {
    style: [{
      flexDirection: "row"
    }, actionsButtonsViewStyle]
  }, isEditable ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AppIcon, {
    icon: AppAssets.icons.check,
    onPress: v => onSubmitIconPress(inputValue),
    isClickable: true,
    wrapperStyle: [{
      marginRight: 5
    }, actionsStyle]
  }), /*#__PURE__*/React__default.createElement(AppIcon, {
    icon: AppAssets.icons.close,
    onPress: () => {
      setInputValue(initialValue);
      onCancelIconPress();
    },
    isClickable: true,
    wrapperStyle: actionsStyle
  })) : isEditEnabled && /*#__PURE__*/React__default.createElement(AppIcon, {
    icon: AppAssets.icons.edit,
    onPress: () => onEditIconPress(),
    isClickable: true,
    wrapperStyle: actionsStyle
  }))));
};
AppSecureTextInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppSecureTextInput",
  "props": {
    "inputType": {
      "defaultValue": {
        "value": "\"TEXT\"",
        "computed": false
      },
      "required": false
    },
    "isEditEnabled": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "onSubmitIconPress": {
      "defaultValue": {
        "value": "(v) => {}",
        "computed": false
      },
      "required": false
    },
    "onCancelIconPress": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onEditIconPress": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onSliderValueChange": {
      "defaultValue": {
        "value": "(v) => {}",
        "computed": false
      },
      "required": false
    },
    "showEditButtons": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppSecureTextInput as A };
